
// import axios from "axios";
// import { useEffect, useRef, useState } from "react";
// import {
//   FiBriefcase,
//   FiCheckCircle,
//   FiClipboard,
//   FiCopy,
//   FiDollarSign,
//   FiEdit2,
//   FiExternalLink,
//   FiEye,
//   FiList,
//   FiPlus,
//   FiSearch,
//   FiTrash2,
//   FiX,
//   FiClock,
//   FiMapPin
// } from "react-icons/fi";
// import { useNavigate } from "react-router-dom";
// import "./EmployeeDashboard.css";

// const API_BASE_URL = 'https://ingrainhirebackend.ingrainsystems.com/api';

// const getTodayDateString = () => {
//   const today = new Date();
//   const yyyy = today.getFullYear();
//   const mm = String(today.getMonth() + 1).padStart(2, '0');
//   const dd = String(today.getDate()).padStart(2, '0');
//   return `${yyyy}-${mm}-${dd}`;
// };

// function PostedShortJobs() {
//   const navigate = useNavigate();

//   // Get clientId from localStorage
//   const getClientId = () => {
//     return localStorage.getItem('clientId') || localStorage.getItem('clientCustomId') || '';
//   };

//   const clientId = getClientId();

//   const [formData, setFormData] = useState({
//     role: "",
//     department: "",
//     vacancies: "",
//     description: "",
//     skills: "",
//     experience: "",
//     location: "",
//     salary: "",
//     assessmentIds: [],
//     startTime: "",
//     endTime: "",
//     totalDuration: "",
//     jobType: "short",
//     companyName: "",
//     aboutCompany: "",
//     startDate: "",
//     endDate: "",
//     startPeriod: "AM",
//     endPeriod: "PM",
//   });

//   const [jobs, setJobs] = useState([]);
//   const [roles, setRoles] = useState([]);
//   const [departments, setDepartments] = useState([]);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [fetchingJobs, setFetchingJobs] = useState(false);
//   const [message, setMessage] = useState({ type: "", text: "" });
//   const [copiedId, setCopiedId] = useState("");
//   const [searchQuery, setSearchQuery] = useState("");
//   const [roleFilter, setRoleFilter] = useState("");
//   const [dateFilter, setDateFilter] = useState("");
//   const [roleSearchQuery, setRoleSearchQuery] = useState("");
//   const [isRoleDropdownOpen, setIsRoleDropdownOpen] = useState(false);
//   const roleDropdownRef = useRef(null);
//   const [isEditing, setIsEditing] = useState(false);
//   const [currentJobId, setCurrentJobId] = useState(null);
//   const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
//   const [selectedJob, setSelectedJob] = useState(null);

//   const [departmentFilter, setDepartmentFilter] = useState("");
//   const [isDeptDropdownOpen, setIsDeptDropdownOpen] = useState(false);
//   const [deptSearchQuery, setDeptSearchQuery] = useState("");
//   const deptDropdownRef = useRef(null);
  
//   const [pagination, setPagination] = useState({
//     currentPage: 1,
//     totalPages: 1,
//     totalCount: 0,
//     limit: 10,
//   });

//   useEffect(() => {
//     if (clientId) {
//       fetchJobs();
//       fetchRoles();
//       fetchDepartments();
//       fetchCompanyDefaults();
//     }

//     const handleClickOutside = (event) => {
//       if (roleDropdownRef.current && !roleDropdownRef.current.contains(event.target)) {
//         setIsRoleDropdownOpen(false);
//       }
//       if (deptDropdownRef.current && !deptDropdownRef.current.contains(event.target)) {
//         setIsDeptDropdownOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, [clientId]);

//   const fetchJobs = async () => {
//     setFetchingJobs(true);
//     try {
//       const res = await axios.get(`${API_BASE_URL}/jobs/all/${clientId}`);
//       if (res.data.success) {
//         const shortJobs = res.data.jobPosts.filter(job => job.jobType === "short");
//         setJobs(shortJobs);
//       }
//     } catch (err) {
//       console.error("Failed to fetch jobs:", err);
//     } finally {
//       setFetchingJobs(false);
//     }
//   };

//   const fetchRoles = async () => {
//     try {
//       const res = await axios.get(`${API_BASE_URL}/roles/all?clientId=${clientId}`);
//       if (res.data.success) {
//         setRoles(res.data.data);
//       }
//     } catch (err) {
//       console.error("Failed to fetch roles:", err);
//     }
//   };

//   const fetchDepartments = async () => {
//     try {
//       const res = await axios.get(`${API_BASE_URL}/employees/get-employees?clientId=${clientId}`);
//       const empData = Array.isArray(res.data) ? res.data : (res.data.employees || []);
//       const uniqueDepartments = [...new Set(empData.map(emp => emp.department).filter(Boolean))];
//       setDepartments(uniqueDepartments.sort());
//     } catch (err) {
//       console.error("Failed to fetch departments:", err);
//     }
//   };

//   const fetchCompanyDefaults = async () => {
//     try {
//       const res = await axios.get(`${API_BASE_URL}/admin/settings`);
//       if (res.data.success && res.data.settings) {
//         const { companyName, aboutCompany } = res.data.settings;
//         setFormData(prev => {
//           if (isEditing) return prev;
//           return {
//             ...prev,
//             companyName: companyName || "Timely Health",
//             aboutCompany: aboutCompany || "",
//           };
//         });
//       }
//     } catch (err) {
//       console.error("Failed to fetch company defaults:", err);
//     }
//   };

//   const openEditModal = (job) => {
//     setIsEditing(true);
//     setCurrentJobId(job._id);
    
//     let sTime = job.startTime || "";
//     let sPeriod = "AM";
//     if (sTime.includes(" ")) {
//       [sTime, sPeriod] = sTime.split(" ");
//     }
    
//     let eTime = job.endTime || "";
//     let ePeriod = "PM";
//     if (eTime.includes(" ")) {
//       [eTime, ePeriod] = eTime.split(" ");
//     }

//     setFormData({
//       role: job.role || "",
//       department: job.department || "",
//       vacancies: job.vacancies || "",
//       description: job.description || "",
//       skills: job.skills || "",
//       experience: job.experience || "",
//       location: job.location || "",
//       salary: job.salary || "",
//       assessmentIds: job.assessmentIds || [],
//       startTime: sTime,
//       endTime: eTime,
//       startPeriod: sPeriod,
//       endPeriod: ePeriod,
//       totalDuration: job.totalDuration || "",
//       jobType: "short",
//       companyName: job.companyName || "",
//       aboutCompany: job.aboutCompany || "",
//       startDate: job.startDate ? new Date(job.startDate).toISOString().split('T')[0] : "",
//       endDate: job.endDate ? new Date(job.endDate).toISOString().split('T')[0] : "",
//       expiryDate: job.expiryDate ? new Date(job.expiryDate).toISOString().split('T')[0] : "",
//     });
//     setIsModalOpen(true);
//   };

//   const handleViewDetails = (job) => {
//     setSelectedJob(job);
//     setIsDetailsModalOpen(true);
//   };

//  const handleDelete = async (id) => {
//   if (!window.confirm("Are you sure you want to delete this short job post?")) {
//     return;
//   }

//   try {
//     const res = await axios.delete(
//       `${API_BASE_URL}/jobs/${id}`
//     );

//     if (res.data.success) {
//       setMessage({
//         type: "success",
//         text: "Short job post deleted successfully!"
//       });
//       fetchJobs();
//       setTimeout(() => {
//         setMessage({
//           type: "",
//           text: ""
//         });
//       }, 3000);
//     }
//   } catch (err) {
//     console.error("Failed to delete job:", err);
//     setMessage({
//       type: "error",
//       text: "Failed to delete job."
//     });
//     setTimeout(() => {
//       setMessage({
//         type: "",
//         text: ""
//       });
//     }, 3000);
//   }
// };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setMessage({ type: "", text: "" });

//     if (!clientId) {
//       setMessage({ type: "error", text: "Client not authenticated. Please login again." });
//       setLoading(false);
//       return;
//     }

//     try {
//       let response;
//       const submissionData = {
//         ...formData,
//         startTime: `${formData.startTime} ${formData.startPeriod}`,
//         endTime: `${formData.endTime} ${formData.endPeriod}`,
//         clientId,
//       };
      
//       if (isEditing) {
//         response = await axios.put(`${API_BASE_URL}/jobs/${currentJobId}/${clientId}`, submissionData);
//       } else {
//         response = await axios.post(`${API_BASE_URL}/jobs/create/${clientId}`, submissionData);
//       }

//       if (response.data.success) {
//         setMessage({ type: "success", text: isEditing ? "Short job updated successfully!" : "Short job posted successfully!" });
//         fetchJobs();
//         setTimeout(() => {
//           setIsModalOpen(false);
//           setMessage({ type: "", text: "" });
//         }, 1500);
//       }
//     } catch (error) {
//       setMessage({ type: "error", text: error.response?.data?.message || "Operation failed." });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const copyToClipboard = (job) => {
//     const fullLink = window.location.origin + job.link;
//     const template = `🕒 Short Job: ${job.role}
    
// ⏰ Timing: ${job.startTime} - ${job.endTime} (${job.totalDuration})
// 📍 Location: ${job.location}
// 💰 Salary: ${job.salary}
// ⏳ Exp: ${job.experience}

// 📝 Description:
// ${job.description}

// 📩 Apply here: ${fullLink}`;

//     navigator.clipboard.writeText(template);
//     setCopiedId(job._id);
//     setTimeout(() => setCopiedId(""), 2200);
//   };

//   const filteredJobs = jobs.filter(job => {
//     const matchesSearch = job.role.toLowerCase().includes(searchQuery.toLowerCase()) ||
//       (job.skills && job.skills.toLowerCase().includes(searchQuery.toLowerCase()));
//     const matchesRole = roleFilter ? (job.role && job.role.toLowerCase() === roleFilter.toLowerCase()) : true;
//     const matchesDept = departmentFilter ? (job.department && job.department.toLowerCase() === departmentFilter.toLowerCase()) : true;
//     const matchesDate = dateFilter
//       ? new Date(job.createdAt).toISOString().slice(0, 10) === dateFilter
//       : true;
//     return matchesSearch && matchesRole && matchesDept && matchesDate;
//   });

//   useEffect(() => {
//     setPagination(prev => ({
//       ...prev,
//       totalCount: filteredJobs.length,
//       totalPages: Math.ceil(filteredJobs.length / prev.limit),
//       currentPage: 1
//     }));
//   }, [filteredJobs.length, searchQuery, roleFilter, departmentFilter, dateFilter]);

//   const indexOfLastItem = pagination.currentPage * pagination.limit;
//   const indexOfFirstItem = indexOfLastItem - pagination.limit;
//   const currentItems = filteredJobs.slice(indexOfFirstItem, indexOfLastItem);

//   const getPageNumbers = () => {
//     const pageNumbers = [];
//     for (let i = 1; i <= pagination.totalPages; i++) {
//       if (i === 1 || i === pagination.totalPages || (i >= pagination.currentPage - 2 && i <= pagination.currentPage + 2)) {
//         pageNumbers.push(i);
//       } else if (i === pagination.currentPage - 3 || i === pagination.currentPage + 3) {
//         pageNumbers.push("...");
//       }
//     }
//     return pageNumbers;
//   };

//   const clearFilters = () => {
//     setSearchQuery("");
//     setRoleFilter("");
//     setDepartmentFilter("");
//     setDateFilter("");
//     setRoleSearchQuery("");
//     setDeptSearchQuery("");
//   };

//   // Mobile card view component for job listings
//   const JobCard = ({ job }) => (
//     <div className="bg-white rounded-xl border border-gray-200 p-4 mb-3 shadow-sm hover:shadow-md transition-shadow">
//       <div className="flex justify-between items-start mb-2">
//         <div>
//           <h3 className="font-bold text-gray-900 text-sm">{job.role}</h3>
//           <span className={`inline-block px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider mt-1 ${job.status === 'active' ? 'bg-emerald-50 text-emerald-600' : 'bg-gray-100 text-gray-400'}`}>
//             {job.status}
//           </span>
//         </div>
//         <div className="flex gap-2">
//           <button
//             onClick={() => handleViewDetails(job)}
//             className="text-blue-500 hover:text-blue-700 p-1"
//             title="View Details"
//           >
//             <FiEye size={16} />
//           </button>
//           <button
//             onClick={() => openEditModal(job)}
//             className="text-yellow-500 hover:text-yellow-700 p-1"
//             title="Edit Job"
//           >
//             <FiEdit2 size={16} />
//           </button>
//           <button
//             onClick={() => handleDelete(job._id)}
//             className="text-red-500 hover:text-red-700 p-1"
//             title="Delete Job"
//           >
//             <FiTrash2 size={16} />
//           </button>
//         </div>
//       </div>
      
//       <div className="grid grid-cols-2 gap-2 text-xs">
//         <div className="bg-gray-50 p-2 rounded">
//           <p className="text-gray-400 text-[10px] uppercase font-bold">Timings</p>
//           <p className="font-medium text-gray-700">{job.startTime} - {job.endTime}</p>
//           <p className="text-blue-500 text-[10px] font-bold">{job.totalDuration}</p>
//         </div>
//         <div className="bg-gray-50 p-2 rounded">
//           <p className="text-gray-400 text-[10px] uppercase font-bold">Salary</p>
//           <p className="font-medium text-emerald-600">{job.salary}</p>
//         </div>
//         <div className="bg-gray-50 p-2 rounded">
//           <p className="text-gray-400 text-[10px] uppercase font-bold">Department</p>
//           <p className="font-medium text-gray-700 truncate">{job.department}</p>
//         </div>
//         <div className="bg-gray-50 p-2 rounded">
//           <p className="text-gray-400 text-[10px] uppercase font-bold">Location</p>
//           <p className="font-medium text-gray-700 truncate">{job.location}</p>
//         </div>
//       </div>
      
//       <div className="mt-2 flex justify-between items-center">
//         <div className="text-xs">
//           <span className="text-gray-400">Deadline: </span>
//           <span className={`font-medium ${job.expiryDate && new Date(job.expiryDate) < new Date(new Date().setHours(0,0,0,0)) ? 'text-rose-600' : 'text-gray-700'}`}>
//             {job.expiryDate ? new Date(job.expiryDate).toLocaleDateString() : 'Not Set'}
//           </span>
//         </div>
//         <div className="flex gap-2">
//           <button
//             onClick={() => copyToClipboard(job)}
//             className={`text-sm ${copiedId === job._id ? "text-emerald-600" : "text-gray-400 hover:text-indigo-600"}`}
//             title="Copy Template"
//           >
//             {copiedId === job._id ? <FiCheckCircle size={16} /> : <FiCopy size={16} />}
//           </button>
//           <button
//             onClick={() => window.open(`${window.location.origin}${job.link}`, "_blank")}
//             className="text-gray-400 hover:text-blue-600"
//             title="Open Link"
//           >
//             <FiExternalLink size={16} />
//           </button>
//         </div>
//       </div>
//     </div>
//   );

//   return (
//     <div style={{backgroundColor:'white'}} className="emp-dash">
//       <div className="p-4 sm:p-6 lg:p-8">
//         {/* Dashboard Header */}
//         <div className="emp-dash__header">
//           <div>
//             <h1 className="emp-dash__greeting">
//               Short <span>Jobs</span>
//             </h1>
//             <p className="emp-dash__subtitle">
//               Manage your short-term job postings
//             </p>
//           </div>
//           <div className="emp-dash__date-pill">
//             <FiClipboard />
//             <span>
//               {new Date().toLocaleDateString("en-US", {
//                 weekday: "short",
//                 year: "numeric",
//                 month: "short",
//                 day: "numeric",
//               })}
//             </span>
//           </div>
//         </div>

//         {/* Filters Section */}
//         <div className="emp-dash__card mb-6">
//           <div className="emp-dash__card-header">
//             <div>
//               <h3 className="emp-dash__card-title flex items-center gap-2">
//                 <FiSearch className="text-blue-600" /> Filter Jobs
//               </h3>
//               <p className="emp-dash__card-desc">Search by role, skills, or date</p>
//             </div>
//           </div>
//           <div className="emp-dash__card-body bg-gray-50/50">
//             <div className="flex flex-wrap items-center gap-2">

//           {/* Search by Role or Skills */}
//           <div className="relative flex-1 min-w-[180px]">
//             <FiSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm" />
//             <input
//               type="text"
//               placeholder="Search by Role or Skills..."
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//               className="w-full pl-8 pr-3 py-1.5 text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-transparent"
//             />
//           </div>

//           {/* Role Filter Button */}
//           <div className="relative" ref={roleDropdownRef}>
//             <button
//               onClick={() => setIsRoleDropdownOpen(!isRoleDropdownOpen)}
//               className={`h-8 px-3 text-xs font-medium rounded-md transition flex items-center gap-1 ${
//                 roleFilter
//                   ? 'bg-blue-600 text-white hover:bg-blue-700'
//                   : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-300'
//               }`}
//             >
//               <FiBriefcase className="text-xs" /> Role {roleFilter && `: ${roleFilter}`}
//             </button>

//             {/* Role Filter Dropdown */}
//             {isRoleDropdownOpen && (
//               <div className="absolute z-50 mt-1 w-48 bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-y-auto">
//                 <div className="p-2 border-b border-gray-100 bg-gray-50">
//                   <div className="relative">
//                     <FiSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-xs" />
//                     <input
//                       type="text"
//                       className="w-full py-1 pl-7 pr-2 text-xs bg-white border border-gray-200 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
//                       placeholder="Search roles..."
//                       value={roleSearchQuery}
//                       onChange={(e) => setRoleSearchQuery(e.target.value)}
//                       onClick={(e) => e.stopPropagation()}
//                       autoFocus
//                     />
//                   </div>
//                 </div>
//                 <div
//                   onClick={() => {
//                     setRoleFilter('');
//                     setIsRoleDropdownOpen(false);
//                     setRoleSearchQuery('');
//                   }}
//                   className={`px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer border-b border-gray-100 font-medium ${
//                     !roleFilter ? 'bg-blue-50 text-blue-700' : 'text-gray-700'
//                   }`}
//                 >
//                   All Roles
//                 </div>
//                 {roles
//                   .filter(r => r.name.toLowerCase().includes(roleSearchQuery.toLowerCase()))
//                   .map((r) => (
//                     <div
//                       key={r._id}
//                       onClick={() => {
//                         setRoleFilter(r.name);
//                         setIsRoleDropdownOpen(false);
//                         setRoleSearchQuery('');
//                       }}
//                       className={`px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer ${
//                         roleFilter === r.name ? 'bg-blue-50 text-blue-700 font-medium' : 'text-gray-700'
//                       }`}
//                     >
//                       {r.name}
//                     </div>
//                   ))}
//                 {roles.filter(r => r.name.toLowerCase().includes(roleSearchQuery.toLowerCase())).length === 0 && (
//                   <div className="px-3 py-2 text-xs text-gray-400 text-center">
//                     No roles found
//                   </div>
//                 )}
//               </div>
//             )}
//           </div>

//           {/* Dept Filter Button */}
//           <div className="relative" ref={deptDropdownRef}>
//             <button
//               onClick={() => setIsDeptDropdownOpen(!isDeptDropdownOpen)}
//               className={`h-8 px-3 text-xs font-medium rounded-md transition flex items-center gap-1 ${
//                 departmentFilter
//                   ? 'bg-blue-600 text-white hover:bg-blue-700'
//                   : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-300'
//               }`}
//             >
//               <FiList className="text-xs" /> Dept {departmentFilter && `: ${departmentFilter}`}
//             </button>

//             {/* Dept Filter Dropdown */}
//             {isDeptDropdownOpen && (
//               <div className="absolute z-50 mt-1 w-48 bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-y-auto">
//                 <div className="p-2 border-b border-gray-100 bg-gray-50">
//                   <div className="relative">
//                     <FiSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-xs" />
//                     <input
//                       type="text"
//                       className="w-full py-1 pl-7 pr-2 text-xs bg-white border border-gray-200 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
//                       placeholder="Search departments..."
//                       value={deptSearchQuery}
//                       onChange={(e) => setDeptSearchQuery(e.target.value)}
//                       onClick={(e) => e.stopPropagation()}
//                       autoFocus
//                     />
//                   </div>
//                 </div>
//                 <div
//                   onClick={() => {
//                     setDepartmentFilter('');
//                     setIsDeptDropdownOpen(false);
//                     setDeptSearchQuery('');
//                   }}
//                   className={`px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer border-b border-gray-100 font-medium ${
//                     !departmentFilter ? 'bg-blue-50 text-blue-700' : 'text-gray-700'
//                   }`}
//                 >
//                   All Depts
//                 </div>
//                 {departments
//                   .filter(d => d.toLowerCase().includes(deptSearchQuery.toLowerCase()))
//                   .map((d, i) => (
//                     <div
//                       key={i}
//                       onClick={() => {
//                         setDepartmentFilter(d);
//                         setIsDeptDropdownOpen(false);
//                         setDeptSearchQuery('');
//                       }}
//                       className={`px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer ${
//                         departmentFilter === d ? 'bg-blue-50 text-blue-700 font-medium' : 'text-gray-700'
//                       }`}
//                     >
//                       {d}
//                     </div>
//                   ))}
//                 {departments.filter(d => d.toLowerCase().includes(deptSearchQuery.toLowerCase())).length === 0 && (
//                   <div className="px-3 py-2 text-xs text-gray-400 text-center">
//                     No departments found
//                   </div>
//                 )}
//               </div>
//             )}
//           </div>

//           {/* Date Filter */}
//           <div className="relative w-[140px]">
//             <input
//               type="date"
//               value={dateFilter}
//               onChange={(e) => setDateFilter(e.target.value)}
//               className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-transparent"
//             />
//           </div>

//           {/* Clear Filters Button */}
//           {(searchQuery || roleFilter || departmentFilter || dateFilter) && (
//             <button
//               onClick={clearFilters}
//               className="h-8 px-3 text-xs font-medium text-gray-600 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 transition"
//             >
//               Clear
//             </button>
//           )}

//           {/* Post New Short Job Button */}
//           <button onClick={() => {
//             setIsEditing(false);
//             setFormData({
//               role: "", department: "", vacancies: "", description: "", skills: "",
//               experience: "", location: "", salary: "", assessmentIds: [],
//               startTime: "", endTime: "", totalDuration: "", jobType: "short",
//               companyName: "", aboutCompany: "", startDate: "", endDate: "",
//               startPeriod: "AM", endPeriod: "PM"
//             });
//             setIsModalOpen(true);
//           }} className="h-8 px-3 text-xs font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 transition flex items-center gap-1 ml-auto">
//             <FiPlus className="text-xs" />
//             <span>Post New Short Job</span>
//           </button>
//             </div>
//           </div>
//         </div>

//       {/* Job Listings - Mobile Responsive */}
//       <div className="emp-dash__card mb-6">
//         {filteredJobs.length > 0 ? (
//           <>
//             {/* Desktop Table - Hidden on mobile */}
//             <div className="hidden md:block emp-dash__table-wrap overflow-x-auto w-full">
//               <table className="emp-dash__table min-w-[800px] w-full">
//                 <thead>
//                   <tr>
//                     <th className="py-2 text-center">Job Role</th>
//                     <th className="py-2 text-center">Timings</th>
//                     <th className="py-2 text-center">Compensation</th>
//                     <th className="py-2 text-center">Dept & Location</th>
//                     <th className="py-2 text-center">Application Deadline</th>
//                     <th className="py-2 text-center">Status</th>
//                     <th className="py-2 text-center">Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {currentItems.map((job) => (
//                     <tr key={job._id} className="border-b hover:bg-gray-50 transition-colors">
//                       <td className="px-2 py-2 font-medium text-center">
//                         <div className="text-gray-900 whitespace-nowrap">{job.role}</div>
//                       </td>
//                       <td className="px-2 py-2 text-center">
//                         <div className="flex flex-col items-center">
//                           <span className="text-sm font-medium text-gray-700">{job.startTime} - {job.endTime}</span>
//                           <span className="text-[10px] text-blue-500 font-bold uppercase">{job.totalDuration}</span>
//                         </div>
//                       </td>
//                       <td className="px-2 py-2 text-center">
//                         <span className="text-emerald-600">{job.salary}</span>
//                       </td>
//                       <td className="px-2 py-2 text-center">
//                         <div className="flex flex-col items-center text-xs">
//                           <span className="font-bold text-gray-700 uppercase tracking-tighter">{job.department}</span>
//                           <span className="text-gray-400">{job.location}</span>
//                         </div>
//                       </td>
//                       <td className="px-2 py-2 text-center">
//                         <span className={`text-xs ${job.expiryDate && new Date(job.expiryDate) < new Date(new Date().setHours(0,0,0,0)) ? 'text-rose-600 font-bold' : 'text-gray-600'}`}>
//                           {job.expiryDate ? new Date(job.expiryDate).toLocaleDateString() : 'Not Set'}
//                         </span>
//                       </td>
//                       <td className="px-2 py-2 text-center">
//                         <span className={`px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider ${job.status === 'active' ? 'bg-emerald-50 text-emerald-600' : 'bg-gray-100 text-gray-400'}`}>
//                           {job.status}
//                         </span>
//                       </td>
//                       <td className="px-2 py-2 text-center">
//                         <div className="flex justify-center gap-2">
//                           <button
//                             onClick={() => handleViewDetails(job)}
//                             className="text-blue-500 hover:text-blue-700"
//                             title="View Details"
//                           >
//                             <FiEye />
//                           </button>
//                           <button
//                             onClick={() => openEditModal(job)}
//                             className="text-yellow-500 hover:text-yellow-700"
//                             title="Edit Job"
//                           >
//                             <FiEdit2 />
//                           </button>
//                           <button
//                             onClick={() => handleDelete(job._id)}
//                             className="text-red-500 hover:text-red-700"
//                             title="Delete Job"
//                           >
//                             <FiTrash2 />
//                           </button>
//                           <button
//                             onClick={() => copyToClipboard(job)}
//                             className={`text-sm ${copiedId === job._id ? "text-emerald-600" : "text-gray-400 hover:text-indigo-600"}`}
//                             title="Copy Template"
//                           >
//                             {copiedId === job._id ? <FiCheckCircle /> : <FiCopy />}
//                           </button>
//                           <button
//                             onClick={() => window.open(`${window.location.origin}${job.link}`, "_blank")}
//                             className="text-gray-400 hover:text-blue-600"
//                             title="Open Link"
//                           >
//                             <FiExternalLink />
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>

//             {/* Mobile Cards - Visible on mobile only */}
//             <div className="md:hidden p-4">
//               {currentItems.map((job) => (
//                 <JobCard key={job._id} job={job} />
//               ))}
//             </div>

//             {/* Pagination */}
//             {filteredJobs.length > 0 && (
//               <div className="flex flex-col items-center justify-between px-4 py-3 border-t border-gray-200 bg-gray-50 sm:flex-row">
//                 <div className="flex flex-wrap items-center gap-2 text-sm text-gray-700">
//                   <span>Showing</span>
//                   <span className="font-medium">{indexOfFirstItem + 1}</span>
//                   <span>to</span>
//                   <span className="font-medium">{Math.min(indexOfLastItem, filteredJobs.length)}</span>
//                   <span>of</span>
//                   <span className="font-medium">{filteredJobs.length}</span>
//                   <span>results</span>
//                 </div>
//                 <div className="flex items-center gap-2 mt-2 sm:mt-0">
//                   <button
//                     onClick={() => setPagination(p => ({ ...p, currentPage: Math.max(1, p.currentPage - 1) }))}
//                     disabled={pagination.currentPage === 1}
//                     className={`px-4 py-2 border rounded-lg text-sm font-medium transition-colors ${pagination.currentPage === 1 ? "bg-gray-100 text-gray-400 cursor-not-allowed" : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"}`}
//                   >
//                     Previous
//                   </button>
//                   {getPageNumbers().map((n, i) => (
//                     <button
//                       key={i}
//                       onClick={() => typeof n === 'number' && setPagination(p => ({ ...p, currentPage: n }))}
//                       disabled={n === '...'}
//                       className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${n === "..." ? "text-gray-500 cursor-default" : pagination.currentPage === n ? "bg-blue-600 text-white" : "bg-white text-gray-700 border border-gray-300 hover:bg-gray-50"}`}
//                     >
//                       {n}
//                     </button>
//                   ))}
//                   <button
//                     onClick={() => setPagination(p => ({ ...p, currentPage: Math.min(pagination.totalPages, p.currentPage + 1) }))}
//                     disabled={pagination.currentPage === pagination.totalPages}
//                     className={`px-4 py-2 border rounded-lg text-sm font-medium transition-colors ${pagination.currentPage === pagination.totalPages ? "bg-gray-100 text-gray-400 cursor-not-allowed" : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"}`}
//                   >
//                     Next
//                   </button>
//                 </div>
//               </div>
//             )}
//           </>
//         ) : (
//           <div className="text-center py-20">
//             <div className="bg-gray-50 w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4">
//               <FiSearch className="text-2xl text-gray-200" />
//             </div>
//             <h2 className="text-lg font-bold text-gray-800">No short jobs found</h2>
//             <p className="text-xs text-gray-400 mt-1">Try adjusting your filters or post a new opening.</p>
//           </div>
//         )}
//       </div>

//       {/* Edit Modal */}
//       {isModalOpen && (
//         <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-gray-900/40 backdrop-blur-[2px] animate-in fade-in duration-200">
//           <div className="bg-white w-full max-w-xl rounded-2xl shadow-2xl overflow-hidden relative animate-in slide-in-from-bottom-4 duration-300">
//             <div className="px-8 pt-8 pb-4 flex items-center justify-between">
//               <div>
//                 <h2 className="text-xl text-gray-800 font-bold">{isEditing ? "Update Short Job" : "Post New Short Job"}</h2>
//                 <p className="text-[10px] font-bold uppercase tracking-widest text-blue-500 mt-1">Management Portal</p>
//               </div>
//               <button onClick={() => setIsModalOpen(false)} className="p-2 text-gray-400 hover:bg-gray-100 rounded-xl transition-all"><FiX size={20} /></button>
//             </div>
            
//             <div className="p-8 pt-4 max-h-[75vh] overflow-y-auto no-scrollbar">
//               {message.text && (
//                 <div className={`mb-6 p-4 rounded-xl flex items-center gap-3 ${message.type === "success" ? "bg-emerald-50 text-emerald-600" : "bg-rose-50 text-rose-600"}`}>
//                   {message.type === "success" ? <FiCheckCircle /> : <FiX />}
//                   <span className="text-sm font-bold">{message.text}</span>
//                 </div>
//               )}
//               <form onSubmit={handleSubmit} className="space-y-5">
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
//                   <div className="space-y-1.5">
//                     <label className="text-sm font-medium text-gray-700">Job Position</label>
//                     <input type="text" name="role" value={formData.role} onChange={handleChange} required className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:ring-1 focus:ring-blue-500 outline-none text-sm" />
//                   </div>

//                    <div className="space-y-1.5">
//                     <label className="text-sm font-medium text-gray-700">Department</label>
//                     <select
//                       name="department"
//                       value={formData.department}
//                       onChange={handleChange}
//                       required
//                       className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:ring-1 focus:ring-blue-500 outline-none text-sm"
//                     >
//                       <option value="">Select Department</option>
//                       {departments.map((dept, i) => (
//                         <option key={i} value={dept}>{dept}</option>
//                       ))}
//                     </select>
//                   </div>
                 
//                   <div className="space-y-1.5">
//                     <label className="text-sm font-medium text-gray-700"> salary / Pay</label>
//                     <input type="text" name="salary" value={formData.salary} onChange={handleChange} required className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:ring-1 focus:ring-blue-500 outline-none text-sm" />
//                   </div>

//                       <div className="space-y-1.5">
//                     <label className="text-sm font-medium text-gray-700">Experience</label>
//                     <input type="text" name="experience" value={formData.experience} onChange={handleChange} required className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:ring-1 focus:ring-blue-500 outline-none text-sm" />
//                   </div>
                  
//                   <div className="space-y-2">
//                     <label className="block text-[10px] font-bold text-gray-400 uppercase tracking-widest">Start Date *</label>
//                     <input type="date" name="startDate" value={formData.startDate} onChange={handleChange} required
//                       className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-indigo-600 outline-none text-sm" />
//                   </div>

//                   <div className="space-y-2">
//                     <label className="block text-[10px] font-bold text-gray-400 uppercase tracking-widest">End Date *</label>
//                     <input type="date" name="endDate" value={formData.endDate} onChange={handleChange} required
//                       className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-indigo-600 outline-none text-sm" />
//                   </div>

//                   <div className="space-y-2">
//                     <label className="block text-[10px] font-bold text-gray-400 uppercase tracking-widest">Start Time *</label>
//                     <div className="flex gap-2">
//                       <input type="time" name="startTime" value={formData.startTime} onChange={handleChange} required
//                         className="flex-1 px-4 py-3 rounded-xl border border-gray-200 focus:border-indigo-600 outline-none text-sm" />
//                       <select
//                         name="startPeriod"
//                         value={formData.startPeriod}
//                         onChange={handleChange}
//                         className="px-2 py-3 rounded-xl border border-gray-200 focus:border-indigo-600 outline-none text-sm bg-white"
//                       >
//                         <option value="AM">AM</option>
//                         <option value="PM">PM</option>
//                       </select>
//                     </div>
//                   </div>

//                   <div className="space-y-2">
//                     <label className="block text-[10px] font-bold text-gray-400 uppercase tracking-widest">End Time *</label>
//                     <div className="flex gap-2">
//                       <input type="time" name="endTime" value={formData.endTime} onChange={handleChange} required
//                         className="flex-1 px-4 py-3 rounded-xl border border-gray-200 focus:border-indigo-600 outline-none text-sm" />
//                       <select
//                         name="endPeriod"
//                         value={formData.endPeriod}
//                         onChange={handleChange}
//                         className="px-2 py-3 rounded-xl border border-gray-200 focus:border-indigo-600 outline-none text-sm bg-white"
//                       >
//                         <option value="AM">AM</option>
//                         <option value="PM">PM</option>
//                       </select>
//                     </div>
//                   </div>
                  
//                   {/* <div className="space-y-1.5">
//                     <label className="text-sm font-medium text-gray-700">Department</label>
//                     <select
//                       name="department"
//                       value={formData.department}
//                       onChange={handleChange}
//                       required
//                       className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:ring-1 focus:ring-blue-500 outline-none text-sm"
//                     >
//                       <option value="">Select Department</option>
//                       {departments.map((dept, i) => (
//                         <option key={i} value={dept}>{dept}</option>
//                       ))}
//                     </select>
//                   </div> */}

//                   <div className="space-y-1.5">
//                     <label className="text-sm font-medium text-gray-700">Total Duration</label>
//                     <input
//                       type="text"
//                       name="totalDuration"
//                       value={formData.totalDuration}
//                       onChange={handleChange}
//                       required
//                       className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:ring-1 focus:ring-blue-500 outline-none text-sm"
//                       placeholder="e.g. 4 Hours"
//                     />
//                   </div>
//                   <div className="space-y-1.5">
//                     <label className="text-sm font-medium text-gray-700">Vacancies</label>
//                     <input
//                       type="number"
//                       name="vacancies"
//                       value={formData.vacancies}
//                       onChange={handleChange}
//                       required
//                       className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:ring-1 focus:ring-blue-500 outline-none text-sm"
//                       min="1"
//                     />
//                   </div>
//                   <div className="space-y-1.5">
//                     <label className="text-sm font-medium text-gray-700">Location</label>
//                     <input type="text" name="location" value={formData.location} onChange={handleChange} required className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:ring-1 focus:ring-blue-500 outline-none text-sm" />
//                   </div>
//                   {/* <div className="space-y-1.5">
//                     <label className="text-sm font-medium text-gray-700">Experience</label>
//                     <input type="text" name="experience" value={formData.experience} onChange={handleChange} required className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:ring-1 focus:ring-blue-500 outline-none text-sm" />
//                   </div> */}
//                   <div className="space-y-1.5">
//                     <label className="text-sm font-medium text-gray-700">Application Deadline</label>
//                     <input
//                       type="date"
//                       name="expiryDate"
//                       value={formData.expiryDate}
//                       onChange={handleChange}
//                       min={getTodayDateString()}
//                       className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:ring-1 focus:ring-blue-500 outline-none text-sm"
//                     />
//                   </div>
//                 </div>
//                 <div className="space-y-1.5">
//                   <label className="text-sm font-medium text-gray-700">Required Skills</label>
//                   <input type="text" name="skills" value={formData.skills} onChange={handleChange} required className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:ring-1 focus:ring-blue-500 outline-none text-sm" placeholder="e.g. Nursing, Patient Care" />
//                 </div>
//                 <div className="space-y-1.5">
//                   <label className="text-sm font-medium text-gray-700">Description</label>
//                   <textarea name="description" value={formData.description} onChange={handleChange} rows={4} required className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:ring-1 focus:ring-blue-500 outline-none text-sm resize-none" />
//                 </div>

//                 <div className="p-4 rounded-2xl bg-indigo-50/50 border border-indigo-100 space-y-4">
//                    <div className="flex items-center gap-2 mb-1">
//                       <FiBriefcase className="text-indigo-600" />
//                       <h3 className="text-xs font-bold text-indigo-600 uppercase tracking-widest">Branding Details</h3>
//                    </div>
                   
//                    <div className="space-y-1.5">
//                     <label className="block text-[10px] font-bold text-gray-400 uppercase tracking-widest">Company Name</label>
//                     <input
//                       type="text"
//                       name="companyName"
//                       value={formData.companyName}
//                       onChange={handleChange}
//                       className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:ring-1 focus:ring-blue-500 outline-none text-sm text-gray-800 bg-white"
//                       placeholder="Timely Health"
//                     />
//                   </div>

//                   <div className="space-y-1.5">
//                     <label className="block text-[10px] font-bold text-gray-400 uppercase tracking-widest">About Company</label>
//                     <textarea
//                       name="aboutCompany"
//                       value={formData.aboutCompany}
//                       onChange={handleChange}
//                       rows="3"
//                       className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:ring-1 focus:ring-blue-500 outline-none text-sm text-gray-800 bg-white resize-none"
//                       placeholder="Brief company overview..."
//                     ></textarea>
//                   </div>
//                 </div>

//                 <div className="flex gap-4 pt-4">
//                   <button type="button" onClick={() => setIsModalOpen(false)} className="flex-1 py-4 text-sm font-bold text-gray-400 hover:bg-gray-50 rounded-xl transition-all">Cancel</button>
//                   <button type="submit" disabled={loading} className="flex-[2] py-4 bg-blue-600 text-white rounded-xl font-bold hover:bg-blue-700 transition-all shadow-lg shadow-blue-600/20">
//                     {loading ? "Processing..." : isEditing ? "Update Job" : "Post Job"}
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Details Modal */}
//       {isDetailsModalOpen && selectedJob && (
//         <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-gray-900/40 backdrop-blur-[2px] animate-in fade-in duration-200">
//           <div className="bg-white w-full max-w-xl rounded-2xl shadow-2xl overflow-hidden relative animate-in slide-in-from-bottom-4 duration-300">
//             <div className="px-8 py-6 bg-gradient-to-r from-blue-600 to-indigo-700 text-white">
//               <h2 className="text-2xl font-bold">{selectedJob.role}</h2>
//               <div className="flex items-center gap-2 mt-1 opacity-90">
//                 <FiMapPin size={12} />
//                 <span className="text-[10px] font-bold uppercase tracking-widest">{selectedJob.location} • {selectedJob.department}</span>
//               </div>
//             </div>
//             <div className="p-8 space-y-6">
//               <div className="grid grid-cols-2 gap-4">
//                 <div className="p-3 bg-gray-50 rounded-xl border border-gray-100">
//                   <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1">Timing</p>
//                   <p className="text-sm font-bold text-gray-900">{selectedJob.startTime} - {selectedJob.endTime}</p>
//                 </div>
//                 <div className="p-3 bg-gray-50 rounded-xl border border-gray-100">
//                   <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1">Shift Dates</p>
//                   <p className="text-sm font-bold text-gray-900">
//                     {selectedJob.startDate ? new Date(selectedJob.startDate).toLocaleDateString() : 'N/A'} - {selectedJob.endDate ? new Date(selectedJob.endDate).toLocaleDateString() : 'N/A'}
//                   </p>
//                 </div>
//                 <div className="p-3 bg-gray-50 rounded-xl border border-gray-100">
//                   <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1">Duration</p>
//                   <p className="text-sm font-bold text-blue-600">{selectedJob.totalDuration}</p>
//                 </div>
//                 <div className="p-3 bg-gray-50 rounded-xl border border-gray-100">
//                   <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1">Salary</p>
//                   <p className="text-sm font-bold text-emerald-600">{selectedJob.salary}</p>
//                 </div>
//                 <div className="p-3 bg-gray-50 rounded-xl border border-gray-100">
//                   <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1">Experience</p>
//                   <p className="text-sm font-bold text-gray-900">{selectedJob.experience}</p>
//                 </div>
//                 <div className={`p-3 rounded-xl border ${selectedJob.expiryDate && new Date(selectedJob.expiryDate) < new Date(new Date().setHours(0,0,0,0)) ? 'bg-rose-50 border-rose-100' : 'bg-gray-50 border-gray-100'}`}>
//                   <p className={`text-[10px] font-bold uppercase tracking-widest mb-1 ${selectedJob.expiryDate && new Date(selectedJob.expiryDate) < new Date(new Date().setHours(0,0,0,0)) ? 'text-rose-400' : 'text-gray-400'}`}>Deadline</p>
//                   <p className={`text-sm font-bold ${selectedJob.expiryDate && new Date(selectedJob.expiryDate) < new Date(new Date().setHours(0,0,0,0)) ? 'text-rose-600' : 'text-gray-900'}`}>
//                     {selectedJob.expiryDate ? new Date(selectedJob.expiryDate).toLocaleDateString() : 'None'}
//                   </p>
//                 </div>
//               </div>
//               <div className="space-y-2">
//                 <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Required Skills</p>
//                 <div className="flex flex-wrap gap-2">
//                   {selectedJob.skills ? selectedJob.skills.split(",").map((s, i) => (
//                     <span key={i} className="px-3 py-1 bg-indigo-50 text-indigo-600 rounded-lg text-xs font-bold border border-indigo-100">{s.trim()}</span>
//                   )) : <span className="text-xs text-gray-400">None specified</span>}
//                 </div>
//               </div>
//               <div className="space-y-2">
//                 <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Job Description</p>
//                 <div className="p-4 bg-gray-50 rounded-xl text-sm text-gray-700 leading-relaxed max-h-40 overflow-y-auto no-scrollbar border border-gray-100">
//                   {selectedJob.description}
//                 </div>
//               </div>

//               <div className="p-4 rounded-2xl bg-indigo-50 border border-indigo-100 space-y-3">
//                  <div className="flex items-center gap-2">
//                     <FiBriefcase className="text-indigo-600" />
//                     <span className="text-xs font-bold text-indigo-600 uppercase tracking-widest">Company Branding</span>
//                  </div>
//                  <div>
//                     <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1">Company Name</p>
//                     <p className="text-sm font-bold text-gray-800">{selectedJob.companyName || "Timely Health"}</p>
//                  </div>
//                  {selectedJob.aboutCompany && (
//                    <div>
//                       <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1">About Company</p>
//                       <p className="text-xs text-gray-600 leading-relaxed italic">{selectedJob.aboutCompany}</p>
//                    </div>
//                  )}
//               </div>

//               <div className="flex gap-4">
//                 <button onClick={() => { setIsDetailsModalOpen(false); openEditModal(selectedJob); }} className="flex-1 py-3 text-sm font-bold text-blue-600 bg-blue-50 hover:bg-blue-100 rounded-xl transition-all">Edit Job</button>
//                 <button onClick={() => setIsDetailsModalOpen(false)} className="flex-1 py-3 text-sm font-bold text-white bg-gray-900 hover:bg-black rounded-xl transition-all">Close</button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//     </div>
//   );
// }

// export default PostedShortJobs;




import axios from "axios";
import { useEffect, useRef, useState } from "react";
import {
  FiBriefcase,
  FiCheckCircle,
  FiClipboard,
  FiCopy,
  FiDollarSign,
  FiEdit2,
  FiExternalLink,
  FiEye,
  FiList,
  FiPlus,
  FiSearch,
  FiTrash2,
  FiX,
  FiClock,
  FiMapPin
} from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import "./EmployeeDashboard.css";

const API_BASE_URL = 'https://ingrainhirebackend.ingrainsystems.com/api';

const getTodayDateString = () => {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const dd = String(today.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

function PostedShortJobs() {
  const navigate = useNavigate();

  // Get clientId from localStorage
  const getClientId = () => {
    return localStorage.getItem('clientId') || localStorage.getItem('clientCustomId') || '';
  };

  const clientId = getClientId();

  const [formData, setFormData] = useState({
    role: "",
    department: "",
    vacancies: "",
    description: "",
    skills: "",
    experience: "",
    location: "",
    salary: "",
    assessmentIds: [],
    startTime: "",
    endTime: "",
    totalDuration: "",
    jobType: "short",
    companyName: "",
    aboutCompany: "",
    startDate: "",
    endDate: "",
    startPeriod: "AM",
    endPeriod: "PM",
  });

  const [jobs, setJobs] = useState([]);
  const [roles, setRoles] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fetchingJobs, setFetchingJobs] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });
  const [copiedId, setCopiedId] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [roleFilter, setRoleFilter] = useState("");
  const [dateFilter, setDateFilter] = useState("");
  const [roleSearchQuery, setRoleSearchQuery] = useState("");
  const [isRoleDropdownOpen, setIsRoleDropdownOpen] = useState(false);
  const roleDropdownRef = useRef(null);
  const [isEditing, setIsEditing] = useState(false);
  const [currentJobId, setCurrentJobId] = useState(null);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);

  const [departmentFilter, setDepartmentFilter] = useState("");
  const [isDeptDropdownOpen, setIsDeptDropdownOpen] = useState(false);
  const [deptSearchQuery, setDeptSearchQuery] = useState("");
  const deptDropdownRef = useRef(null);
  
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    limit: 10,
  });

  useEffect(() => {
    if (clientId) {
      fetchJobs();
      fetchRoles();
      fetchDepartments();
      fetchCompanyDefaults();
    }

    const handleClickOutside = (event) => {
      if (roleDropdownRef.current && !roleDropdownRef.current.contains(event.target)) {
        setIsRoleDropdownOpen(false);
      }
      if (deptDropdownRef.current && !deptDropdownRef.current.contains(event.target)) {
        setIsDeptDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [clientId]);

  const fetchJobs = async () => {
    setFetchingJobs(true);
    try {
      const res = await axios.get(`${API_BASE_URL}/jobs/all/${clientId}`);
      if (res.data.success) {
        const shortJobs = res.data.jobPosts.filter(job => job.jobType === "short");
        setJobs(shortJobs);
      }
    } catch (err) {
      console.error("Failed to fetch jobs:", err);
    } finally {
      setFetchingJobs(false);
    }
  };

  const fetchRoles = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/roles/all?clientId=${clientId}`);
      if (res.data.success) {
        setRoles(res.data.data);
      }
    } catch (err) {
      console.error("Failed to fetch roles:", err);
    }
  };

  const fetchDepartments = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/employees/get-employees?clientId=${clientId}`);
      const empData = Array.isArray(res.data) ? res.data : (res.data.employees || []);
      const uniqueDepartments = [...new Set(empData.map(emp => emp.department).filter(Boolean))];
      setDepartments(uniqueDepartments.sort());
    } catch (err) {
      console.error("Failed to fetch departments:", err);
    }
  };

  const fetchCompanyDefaults = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/admin/settings`);
      if (res.data.success && res.data.settings) {
        const { companyName, aboutCompany } = res.data.settings;
        setFormData(prev => {
          if (isEditing) return prev;
          return {
            ...prev,
            companyName: companyName || "Timely Health",
            aboutCompany: aboutCompany || "",
          };
        });
      }
    } catch (err) {
      console.error("Failed to fetch company defaults:", err);
    }
  };

  const openEditModal = (job) => {
    setIsEditing(true);
    setCurrentJobId(job._id);
    
    let sTime = job.startTime || "";
    let sPeriod = "AM";
    if (sTime.includes(" ")) {
      [sTime, sPeriod] = sTime.split(" ");
    }
    
    let eTime = job.endTime || "";
    let ePeriod = "PM";
    if (eTime.includes(" ")) {
      [eTime, ePeriod] = eTime.split(" ");
    }

    setFormData({
      role: job.role || "",
      department: job.department || "",
      vacancies: job.vacancies || "",
      description: job.description || "",
      skills: job.skills || "",
      experience: job.experience || "",
      location: job.location || "",
      salary: job.salary || "",
      assessmentIds: job.assessmentIds || [],
      startTime: sTime,
      endTime: eTime,
      startPeriod: sPeriod,
      endPeriod: ePeriod,
      totalDuration: job.totalDuration || "",
      jobType: "short",
      companyName: job.companyName || "",
      aboutCompany: job.aboutCompany || "",
      startDate: job.startDate ? new Date(job.startDate).toISOString().split('T')[0] : "",
      endDate: job.endDate ? new Date(job.endDate).toISOString().split('T')[0] : "",
      expiryDate: job.expiryDate ? new Date(job.expiryDate).toISOString().split('T')[0] : "",
    });
    setIsModalOpen(true);
  };

  const handleViewDetails = (job) => {
    setSelectedJob(job);
    setIsDetailsModalOpen(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this short job post?")) {
      return;
    }

    try {
      const res = await axios.delete(
        `${API_BASE_URL}/jobs/${id}`
      );

      if (res.data.success) {
        setMessage({
          type: "success",
          text: "Short job post deleted successfully!"
        });
        fetchJobs();
        setTimeout(() => {
          setMessage({
            type: "",
            text: ""
          });
        }, 3000);
      }
    } catch (err) {
      console.error("Failed to delete job:", err);
      setMessage({
        type: "error",
        text: "Failed to delete job."
      });
      setTimeout(() => {
        setMessage({
          type: "",
          text: ""
        });
      }, 3000);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    
    // Clear date validation error when user changes either date
    if (name === 'startDate' || name === 'endDate') {
      setMessage(prev => {
        if (prev.text && (prev.text.includes('Start date cannot be in the past') || prev.text.includes('End date must be after start date'))) {
          return { type: "", text: "" };
        }
        return prev;
      });
    }
  };

  // Validate dates before submission
  const validateDates = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    if (formData.startDate) {
      const startDate = new Date(formData.startDate);
      startDate.setHours(0, 0, 0, 0);
      
      if (startDate < today) {
        setMessage({ 
          type: "error", 
          text: "Start date cannot be in the past. Please select today or a future date." 
        });
        return false;
      }
    }
    
    if (formData.startDate && formData.endDate) {
      const start = new Date(formData.startDate);
      const end = new Date(formData.endDate);
      start.setHours(0, 0, 0, 0);
      end.setHours(0, 0, 0, 0);
      
      if (end < start) {
        setMessage({ 
          type: "error", 
          text: "End date must be after start date. Please select a valid date range." 
        });
        return false;
      }
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate dates before proceeding
    if (!validateDates()) {
      return;
    }
    
    setLoading(true);
    setMessage({ type: "", text: "" });

    if (!clientId) {
      setMessage({ type: "error", text: "Client not authenticated. Please login again." });
      setLoading(false);
      return;
    }

    try {
      let response;
      const submissionData = {
        ...formData,
        startTime: `${formData.startTime} ${formData.startPeriod}`,
        endTime: `${formData.endTime} ${formData.endPeriod}`,
        clientId,
      };
      
      if (isEditing) {
        response = await axios.put(`${API_BASE_URL}/jobs/${currentJobId}/${clientId}`, submissionData);
      } else {
        response = await axios.post(`${API_BASE_URL}/jobs/create/${clientId}`, submissionData);
      }

      if (response.data.success) {
        setMessage({ type: "success", text: isEditing ? "Short job updated successfully!" : "Short job posted successfully!" });
        fetchJobs();
        setTimeout(() => {
          setIsModalOpen(false);
          setMessage({ type: "", text: "" });
        }, 1500);
      }
    } catch (error) {
      setMessage({ type: "error", text: error.response?.data?.message || "Operation failed." });
    } finally {
      setLoading(false);
    }
  };

  const copyToClipboard = (job) => {
    const fullLink = window.location.origin + job.link;
    const template = `🕒 Short Job: ${job.role}
    
⏰ Timing: ${job.startTime} - ${job.endTime} (${job.totalDuration})
📍 Location: ${job.location}
💰 Salary: ${job.salary}
⏳ Exp: ${job.experience}

📝 Description:
${job.description}

📩 Apply here: ${fullLink}`;

    navigator.clipboard.writeText(template);
    setCopiedId(job._id);
    setTimeout(() => setCopiedId(""), 2200);
  };

  const filteredJobs = jobs.filter(job => {
    const matchesSearch = job.role.toLowerCase().includes(searchQuery.toLowerCase()) ||
      (job.skills && job.skills.toLowerCase().includes(searchQuery.toLowerCase()));
    const matchesRole = roleFilter ? (job.role && job.role.toLowerCase() === roleFilter.toLowerCase()) : true;
    const matchesDept = departmentFilter ? (job.department && job.department.toLowerCase() === departmentFilter.toLowerCase()) : true;
    const matchesDate = dateFilter
      ? new Date(job.createdAt).toISOString().slice(0, 10) === dateFilter
      : true;
    return matchesSearch && matchesRole && matchesDept && matchesDate;
  });

  useEffect(() => {
    setPagination(prev => ({
      ...prev,
      totalCount: filteredJobs.length,
      totalPages: Math.ceil(filteredJobs.length / prev.limit),
      currentPage: 1
    }));
  }, [filteredJobs.length, searchQuery, roleFilter, departmentFilter, dateFilter]);

  const indexOfLastItem = pagination.currentPage * pagination.limit;
  const indexOfFirstItem = indexOfLastItem - pagination.limit;
  const currentItems = filteredJobs.slice(indexOfFirstItem, indexOfLastItem);

  const getPageNumbers = () => {
    const pageNumbers = [];
    for (let i = 1; i <= pagination.totalPages; i++) {
      if (i === 1 || i === pagination.totalPages || (i >= pagination.currentPage - 2 && i <= pagination.currentPage + 2)) {
        pageNumbers.push(i);
      } else if (i === pagination.currentPage - 3 || i === pagination.currentPage + 3) {
        pageNumbers.push("...");
      }
    }
    return pageNumbers;
  };

  const clearFilters = () => {
    setSearchQuery("");
    setRoleFilter("");
    setDepartmentFilter("");
    setDateFilter("");
    setRoleSearchQuery("");
    setDeptSearchQuery("");
  };

  // Mobile card view component for job listings
  const JobCard = ({ job }) => (
    <div className="bg-white rounded-xl border border-gray-200 p-4 mb-3 shadow-sm hover:shadow-md transition-shadow">
      <div className="flex justify-between items-start mb-2">
        <div>
          <h3 className="font-bold text-gray-900 text-sm">{job.role}</h3>
          <span className={`inline-block px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider mt-1 ${job.status === 'active' ? 'bg-emerald-50 text-emerald-600' : 'bg-gray-100 text-gray-400'}`}>
            {job.status}
          </span>
        </div>
        <div className="flex gap-2">
          <button
            onClick={() => handleViewDetails(job)}
            className="text-blue-500 hover:text-blue-700 p-1"
            title="View Details"
          >
            <FiEye size={16} />
          </button>
          <button
            onClick={() => openEditModal(job)}
            className="text-yellow-500 hover:text-yellow-700 p-1"
            title="Edit Job"
          >
            <FiEdit2 size={16} />
          </button>
          <button
            onClick={() => handleDelete(job._id)}
            className="text-red-500 hover:text-red-700 p-1"
            title="Delete Job"
          >
            <FiTrash2 size={16} />
          </button>
        </div>
      </div>
      
      <div className="grid grid-cols-2 gap-2 text-xs">
        <div className="bg-gray-50 p-2 rounded">
          <p className="text-gray-400 text-[10px] uppercase font-bold">Timings</p>
          <p className="font-medium text-gray-700">{job.startTime} - {job.endTime}</p>
          <p className="text-blue-500 text-[10px] font-bold">{job.totalDuration}</p>
        </div>
        <div className="bg-gray-50 p-2 rounded">
          <p className="text-gray-400 text-[10px] uppercase font-bold">Salary</p>
          <p className="font-medium text-emerald-600">{job.salary}</p>
        </div>
        <div className="bg-gray-50 p-2 rounded">
          <p className="text-gray-400 text-[10px] uppercase font-bold">Department</p>
          <p className="font-medium text-gray-700 truncate">{job.department}</p>
        </div>
        <div className="bg-gray-50 p-2 rounded">
          <p className="text-gray-400 text-[10px] uppercase font-bold">Location</p>
          <p className="font-medium text-gray-700 truncate">{job.location}</p>
        </div>
      </div>
      
      <div className="mt-2 flex justify-between items-center">
        <div className="text-xs">
          <span className="text-gray-400">Deadline: </span>
          <span className={`font-medium ${job.expiryDate && new Date(job.expiryDate) < new Date(new Date().setHours(0,0,0,0)) ? 'text-rose-600' : 'text-gray-700'}`}>
            {job.expiryDate ? new Date(job.expiryDate).toLocaleDateString() : 'Not Set'}
          </span>
        </div>
        <div className="flex gap-2">
          <button
            onClick={() => copyToClipboard(job)}
            className={`text-sm ${copiedId === job._id ? "text-emerald-600" : "text-gray-400 hover:text-indigo-600"}`}
            title="Copy Template"
          >
            {copiedId === job._id ? <FiCheckCircle size={16} /> : <FiCopy size={16} />}
          </button>
          <button
            onClick={() => window.open(`${window.location.origin}${job.link}`, "_blank")}
            className="text-gray-400 hover:text-blue-600"
            title="Open Link"
          >
            <FiExternalLink size={16} />
          </button>
        </div>
      </div>
    </div>
  );

  // Check if start date is in the past
  const isStartDateInPast = () => {
    if (!formData.startDate) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const startDate = new Date(formData.startDate);
    startDate.setHours(0, 0, 0, 0);
    return startDate < today;
  };

  // Check if end date is before start date
  const isEndDateBeforeStart = () => {
    if (!formData.startDate || !formData.endDate) return false;
    const start = new Date(formData.startDate);
    const end = new Date(formData.endDate);
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);
    return end < start;
  };

  // Check if form has date validation errors
  const hasDateErrors = () => {
    return isStartDateInPast() || isEndDateBeforeStart();
  };

  return (
    <div style={{backgroundColor:'white'}} className="emp-dash">
      <div className="">
        {/* Dashboard Header */}
        <div className="emp-dash__header">
          <div>
            <h1 className="emp-dash__greeting">
              Short <span>Jobs</span>
            </h1>
            <p className="emp-dash__subtitle">
              Manage your short-term job postings
            </p>
          </div>
          <div className="emp-dash__date-pill">
            <FiClipboard />
            <span>
              {new Date().toLocaleDateString("en-US", {
                weekday: "short",
                year: "numeric",
                month: "short",
                day: "numeric",
              })}
            </span>
          </div>
        </div>

        {/* Filters Section */}
        <div className="emp-dash__card mb-6">
          <div className="emp-dash__card-header">
            <div>
              <h3 className="emp-dash__card-title flex items-center gap-2">
                <FiSearch className="text-blue-600" /> Filter Jobs
              </h3>
              <p className="emp-dash__card-desc">Search by role, skills, or date</p>
            </div>
          </div>
          <div className="emp-dash__card-body bg-gray-50/50">
            <div className="flex flex-wrap items-center gap-2">

          {/* Search by Role or Skills */}
          <div className="relative flex-1 min-w-[180px]">
            <FiSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm" />
            <input
              type="text"
              placeholder="Search by Role or Skills..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full pl-8 pr-3 py-1.5 text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-transparent"
            />
          </div>

          {/* Role Filter Button */}
          <div className="relative" ref={roleDropdownRef}>
            <button
              onClick={() => setIsRoleDropdownOpen(!isRoleDropdownOpen)}
              className={`h-8 px-3 text-xs font-medium rounded-md transition flex items-center gap-1 ${
                roleFilter
                  ? 'bg-blue-600 text-white hover:bg-blue-700'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-300'
              }`}
            >
              <FiBriefcase className="text-xs" /> Role {roleFilter && `: ${roleFilter}`}
            </button>

            {/* Role Filter Dropdown */}
            {isRoleDropdownOpen && (
              <div className="absolute z-50 mt-1 w-48 bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-y-auto">
                <div className="p-2 border-b border-gray-100 bg-gray-50">
                  <div className="relative">
                    <FiSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-xs" />
                    <input
                      type="text"
                      className="w-full py-1 pl-7 pr-2 text-xs bg-white border border-gray-200 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                      placeholder="Search roles..."
                      value={roleSearchQuery}
                      onChange={(e) => setRoleSearchQuery(e.target.value)}
                      onClick={(e) => e.stopPropagation()}
                      autoFocus
                    />
                  </div>
                </div>
                <div
                  onClick={() => {
                    setRoleFilter('');
                    setIsRoleDropdownOpen(false);
                    setRoleSearchQuery('');
                  }}
                  className={`px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer border-b border-gray-100 font-medium ${
                    !roleFilter ? 'bg-blue-50 text-blue-700' : 'text-gray-700'
                  }`}
                >
                  All Roles
                </div>
                {roles
                  .filter(r => r.name.toLowerCase().includes(roleSearchQuery.toLowerCase()))
                  .map((r) => (
                    <div
                      key={r._id}
                      onClick={() => {
                        setRoleFilter(r.name);
                        setIsRoleDropdownOpen(false);
                        setRoleSearchQuery('');
                      }}
                      className={`px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer ${
                        roleFilter === r.name ? 'bg-blue-50 text-blue-700 font-medium' : 'text-gray-700'
                      }`}
                    >
                      {r.name}
                    </div>
                  ))}
                {roles.filter(r => r.name.toLowerCase().includes(roleSearchQuery.toLowerCase())).length === 0 && (
                  <div className="px-3 py-2 text-xs text-gray-400 text-center">
                    No roles found
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Dept Filter Button */}
          <div className="relative" ref={deptDropdownRef}>
            <button
              onClick={() => setIsDeptDropdownOpen(!isDeptDropdownOpen)}
              className={`h-8 px-3 text-xs font-medium rounded-md transition flex items-center gap-1 ${
                departmentFilter
                  ? 'bg-blue-600 text-white hover:bg-blue-700'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-300'
              }`}
            >
              <FiList className="text-xs" /> Dept {departmentFilter && `: ${departmentFilter}`}
            </button>

            {/* Dept Filter Dropdown */}
            {isDeptDropdownOpen && (
              <div className="absolute z-50 mt-1 w-48 bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-y-auto">
                <div className="p-2 border-b border-gray-100 bg-gray-50">
                  <div className="relative">
                    <FiSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 text-xs" />
                    <input
                      type="text"
                      className="w-full py-1 pl-7 pr-2 text-xs bg-white border border-gray-200 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                      placeholder="Search departments..."
                      value={deptSearchQuery}
                      onChange={(e) => setDeptSearchQuery(e.target.value)}
                      onClick={(e) => e.stopPropagation()}
                      autoFocus
                    />
                  </div>
                </div>
                <div
                  onClick={() => {
                    setDepartmentFilter('');
                    setIsDeptDropdownOpen(false);
                    setDeptSearchQuery('');
                  }}
                  className={`px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer border-b border-gray-100 font-medium ${
                    !departmentFilter ? 'bg-blue-50 text-blue-700' : 'text-gray-700'
                  }`}
                >
                  All Depts
                </div>
                {departments
                  .filter(d => d.toLowerCase().includes(deptSearchQuery.toLowerCase()))
                  .map((d, i) => (
                    <div
                      key={i}
                      onClick={() => {
                        setDepartmentFilter(d);
                        setIsDeptDropdownOpen(false);
                        setDeptSearchQuery('');
                      }}
                      className={`px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer ${
                        departmentFilter === d ? 'bg-blue-50 text-blue-700 font-medium' : 'text-gray-700'
                      }`}
                    >
                      {d}
                    </div>
                  ))}
                {departments.filter(d => d.toLowerCase().includes(deptSearchQuery.toLowerCase())).length === 0 && (
                  <div className="px-3 py-2 text-xs text-gray-400 text-center">
                    No departments found
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Date Filter */}
          <div className="relative w-[140px]">
            <input
              type="date"
              value={dateFilter}
              onChange={(e) => setDateFilter(e.target.value)}
              className="w-full px-2 py-1.5 text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-transparent"
            />
          </div>

          {/* Clear Filters Button */}
          {(searchQuery || roleFilter || departmentFilter || dateFilter) && (
            <button
              onClick={clearFilters}
              className="h-8 px-3 text-xs font-medium text-gray-600 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 transition"
            >
              Clear
            </button>
          )}

          {/* Post New Short Job Button */}
          <button onClick={() => {
            setIsEditing(false);
            setFormData({
              role: "", department: "", vacancies: "", description: "", skills: "",
              experience: "", location: "", salary: "", assessmentIds: [],
              startTime: "", endTime: "", totalDuration: "", jobType: "short",
              companyName: "", aboutCompany: "", startDate: "", endDate: "",
              startPeriod: "AM", endPeriod: "PM"
            });
            setIsModalOpen(true);
          }} className="h-8 px-3 text-xs font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 transition flex items-center gap-1 ml-auto">
            <FiPlus className="text-xs" />
            <span>Post New Short Job</span>
          </button>
            </div>
          </div>
        </div>

      {/* Job Listings - Mobile Responsive */}
      <div className="emp-dash__card mb-6">
        {filteredJobs.length > 0 ? (
          <>
            {/* Desktop Table - Hidden on mobile */}
            <div className="hidden md:block emp-dash__table-wrap overflow-x-auto w-full">
              <table className="emp-dash__table min-w-[800px] w-full">
                <thead>
                  <tr>
                    <th className="py-2 text-center">Job Role</th>
                    <th className="py-2 text-center">Timings</th>
                    <th className="py-2 text-center">Compensation</th>
                    <th className="py-2 text-center">Dept & Location</th>
                    <th className="py-2 text-center">Application Deadline</th>
                    <th className="py-2 text-center">Status</th>
                    <th className="py-2 text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map((job) => (
                    <tr key={job._id} className="border-b hover:bg-gray-50 transition-colors">
                      <td className="px-2 py-2 font-medium text-center">
                        <div className="text-gray-900 whitespace-nowrap">{job.role}</div>
                      </td>
                      <td className="px-2 py-2 text-center">
                        <div className="flex flex-col items-center">
                          <span className="text-sm font-medium text-gray-700">{job.startTime} - {job.endTime}</span>
                          <span className="text-[10px] text-blue-500 font-bold uppercase">{job.totalDuration}</span>
                        </div>
                      </td>
                      <td className="px-2 py-2 text-center">
                        <span className="text-emerald-600">{job.salary}</span>
                      </td>
                      <td className="px-2 py-2 text-center">
                        <div className="flex flex-col items-center text-xs">
                          <span className="font-bold text-gray-700 uppercase tracking-tighter">{job.department}</span>
                          <span className="text-gray-400">{job.location}</span>
                        </div>
                      </td>
                      <td className="px-2 py-2 text-center">
                        <span className={`text-xs ${job.expiryDate && new Date(job.expiryDate) < new Date(new Date().setHours(0,0,0,0)) ? 'text-rose-600 font-bold' : 'text-gray-600'}`}>
                          {job.expiryDate ? new Date(job.expiryDate).toLocaleDateString() : 'Not Set'}
                        </span>
                      </td>
                      <td className="px-2 py-2 text-center">
                        <span className={`px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider ${job.status === 'active' ? 'bg-emerald-50 text-emerald-600' : 'bg-gray-100 text-gray-400'}`}>
                          {job.status}
                        </span>
                      </td>
                      <td className="px-2 py-2 text-center">
                        <div className="flex justify-center gap-2">
                          <button
                            onClick={() => handleViewDetails(job)}
                            className="text-blue-500 hover:text-blue-700"
                            title="View Details"
                          >
                            <FiEye />
                          </button>
                          <button
                            onClick={() => openEditModal(job)}
                            className="text-yellow-500 hover:text-yellow-700"
                            title="Edit Job"
                          >
                            <FiEdit2 />
                          </button>
                          <button
                            onClick={() => handleDelete(job._id)}
                            className="text-red-500 hover:text-red-700"
                            title="Delete Job"
                          >
                            <FiTrash2 />
                          </button>
                          <button
                            onClick={() => copyToClipboard(job)}
                            className={`text-sm ${copiedId === job._id ? "text-emerald-600" : "text-gray-400 hover:text-indigo-600"}`}
                            title="Copy Template"
                          >
                            {copiedId === job._id ? <FiCheckCircle /> : <FiCopy />}
                          </button>
                          <button
                            onClick={() => window.open(`${window.location.origin}${job.link}`, "_blank")}
                            className="text-gray-400 hover:text-blue-600"
                            title="Open Link"
                          >
                            <FiExternalLink />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Mobile Cards - Visible on mobile only */}
            <div className="md:hidden p-4">
              {currentItems.map((job) => (
                <JobCard key={job._id} job={job} />
              ))}
            </div>

            {/* Pagination */}
            {filteredJobs.length > 0 && (
              <div className="flex flex-col items-center justify-between px-4 py-3 border-t border-gray-200 bg-gray-50 sm:flex-row">
                <div className="flex flex-wrap items-center gap-2 text-sm text-gray-700">
                  <span>Showing</span>
                  <span className="font-medium">{indexOfFirstItem + 1}</span>
                  <span>to</span>
                  <span className="font-medium">{Math.min(indexOfLastItem, filteredJobs.length)}</span>
                  <span>of</span>
                  <span className="font-medium">{filteredJobs.length}</span>
                  <span>results</span>
                </div>
                <div className="flex items-center gap-2 mt-2 sm:mt-0">
                  <button
                    onClick={() => setPagination(p => ({ ...p, currentPage: Math.max(1, p.currentPage - 1) }))}
                    disabled={pagination.currentPage === 1}
                    className={`px-4 py-2 border rounded-lg text-sm font-medium transition-colors ${pagination.currentPage === 1 ? "bg-gray-100 text-gray-400 cursor-not-allowed" : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"}`}
                  >
                    Previous
                  </button>
                  {getPageNumbers().map((n, i) => (
                    <button
                      key={i}
                      onClick={() => typeof n === 'number' && setPagination(p => ({ ...p, currentPage: n }))}
                      disabled={n === '...'}
                      className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${n === "..." ? "text-gray-500 cursor-default" : pagination.currentPage === n ? "bg-blue-600 text-white" : "bg-white text-gray-700 border border-gray-300 hover:bg-gray-50"}`}
                    >
                      {n}
                    </button>
                  ))}
                  <button
                    onClick={() => setPagination(p => ({ ...p, currentPage: Math.min(pagination.totalPages, p.currentPage + 1) }))}
                    disabled={pagination.currentPage === pagination.totalPages}
                    className={`px-4 py-2 border rounded-lg text-sm font-medium transition-colors ${pagination.currentPage === pagination.totalPages ? "bg-gray-100 text-gray-400 cursor-not-allowed" : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"}`}
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </>
        ) : (
          <div className="text-center py-20">
            <div className="bg-gray-50 w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <FiSearch className="text-2xl text-gray-200" />
            </div>
            <h2 className="text-lg font-bold text-gray-800">No short jobs found</h2>
            <p className="text-xs text-gray-400 mt-1">Try adjusting your filters or post a new opening.</p>
          </div>
        )}
      </div>

      {/* Edit Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-gray-900/40 backdrop-blur-[2px] animate-in fade-in duration-200">
          <div className="bg-white w-full max-w-xl rounded-2xl shadow-2xl overflow-hidden relative animate-in slide-in-from-bottom-4 duration-300">
            <div className="px-8 pt-8 pb-4 flex items-center justify-between">
              <div>
                <h2 className="text-xl text-gray-800 font-bold">{isEditing ? "Update Short Job" : "Post New Short Job"}</h2>
                <p className="text-[10px] font-bold uppercase tracking-widest text-blue-500 mt-1">Management Portal</p>
              </div>
              <button onClick={() => setIsModalOpen(false)} className="p-2 text-gray-400 hover:bg-gray-100 rounded-xl transition-all"><FiX size={20} /></button>
            </div>
            
            <div className="p-8 pt-4 max-h-[75vh] overflow-y-auto no-scrollbar">
              {message.text && (
                <div className={`mb-6 p-4 rounded-xl flex items-center gap-3 ${message.type === "success" ? "bg-emerald-50 text-emerald-600" : "bg-rose-50 text-rose-600"}`}>
                  {message.type === "success" ? <FiCheckCircle /> : <FiX />}
                  <span className="text-sm font-bold">{message.text}</span>
                </div>
              )}
              <form onSubmit={handleSubmit} className="space-y-5">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                  <div className="space-y-1.5">
                    <label className="text-sm font-medium text-gray-700">Job Position</label>
                    <input type="text" name="role" value={formData.role} onChange={handleChange} required className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:ring-1 focus:ring-blue-500 outline-none text-sm" />
                  </div>

                   <div className="space-y-1.5">
                    <label className="text-sm font-medium text-gray-700">Department</label>
                    <select
                      name="department"
                      value={formData.department}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:ring-1 focus:ring-blue-500 outline-none text-sm"
                    >
                      <option value="">Select Department</option>
                      {departments.map((dept, i) => (
                        <option key={i} value={dept}>{dept}</option>
                      ))}
                    </select>
                  </div>
                 
                  <div className="space-y-1.5">
                    <label className="text-sm font-medium text-gray-700"> salary / Pay</label>
                    <input type="text" name="salary" value={formData.salary} onChange={handleChange} required className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:ring-1 focus:ring-blue-500 outline-none text-sm" />
                  </div>

                      <div className="space-y-1.5">
                    <label className="text-sm font-medium text-gray-700">Experience</label>
                    <input type="text" name="experience" value={formData.experience} onChange={handleChange} required className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:ring-1 focus:ring-blue-500 outline-none text-sm" />
                  </div>
                  
                  <div className="space-y-2">
                    <label className="block text-[10px] font-bold text-gray-400 uppercase tracking-widest">Start Date *</label>
                    <input 
                      type="date" 
                      name="startDate" 
                      value={formData.startDate} 
                      onChange={handleChange} 
                      required
                      min={getTodayDateString()}
                      className={`w-full px-4 py-3 rounded-xl border focus:border-indigo-600 outline-none text-sm ${
                        isStartDateInPast() ? 'border-rose-500 bg-rose-50' : 'border-gray-200'
                      }`}
                    />
                    {isStartDateInPast() && (
                      <p className="text-xs text-rose-600 mt-1 flex items-center gap-1">
                        <FiX size={12} /> Start date cannot be in the past
                      </p>
                    )}
                  </div>

                  <div className="space-y-2">
                    <label className="block text-[10px] font-bold text-gray-400 uppercase tracking-widest">End Date *</label>
                    <input 
                      type="date" 
                      name="endDate" 
                      value={formData.endDate} 
                      onChange={handleChange} 
                      required
                      min={formData.startDate || getTodayDateString()}
                      className={`w-full px-4 py-3 rounded-xl border focus:border-indigo-600 outline-none text-sm ${
                        isEndDateBeforeStart() ? 'border-rose-500 bg-rose-50' : 'border-gray-200'
                      }`}
                    />
                    {isEndDateBeforeStart() && (
                      <p className="text-xs text-rose-600 mt-1 flex items-center gap-1">
                        <FiX size={12} /> End date must be after start date
                      </p>
                    )}
                  </div>

                  <div className="space-y-2">
                    <label className="block text-[10px] font-bold text-gray-400 uppercase tracking-widest">Start Time *</label>
                    <div className="flex gap-2">
                      <input type="time" name="startTime" value={formData.startTime} onChange={handleChange} required
                        className="flex-1 px-4 py-3 rounded-xl border border-gray-200 focus:border-indigo-600 outline-none text-sm" />
                      <select
                        name="startPeriod"
                        value={formData.startPeriod}
                        onChange={handleChange}
                        className="px-2 py-3 rounded-xl border border-gray-200 focus:border-indigo-600 outline-none text-sm bg-white"
                      >
                        <option value="AM">AM</option>
                        <option value="PM">PM</option>
                      </select>
                    </div>
                  </div>

                  <div className="space-y-2">
                    <label className="block text-[10px] font-bold text-gray-400 uppercase tracking-widest">End Time *</label>
                    <div className="flex gap-2">
                      <input type="time" name="endTime" value={formData.endTime} onChange={handleChange} required
                        className="flex-1 px-4 py-3 rounded-xl border border-gray-200 focus:border-indigo-600 outline-none text-sm" />
                      <select
                        name="endPeriod"
                        value={formData.endPeriod}
                        onChange={handleChange}
                        className="px-2 py-3 rounded-xl border border-gray-200 focus:border-indigo-600 outline-none text-sm bg-white"
                      >
                        <option value="AM">AM</option>
                        <option value="PM">PM</option>
                      </select>
                    </div>
                  </div>

                  <div className="space-y-1.5">
                    <label className="text-sm font-medium text-gray-700">Total Duration</label>
                    <input
                      type="text"
                      name="totalDuration"
                      value={formData.totalDuration}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:ring-1 focus:ring-blue-500 outline-none text-sm"
                      placeholder="e.g. 4 Hours"
                    />
                  </div>
                  <div className="space-y-1.5">
                    <label className="text-sm font-medium text-gray-700">Vacancies</label>
                    <input
                      type="number"
                      name="vacancies"
                      value={formData.vacancies}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:ring-1 focus:ring-blue-500 outline-none text-sm"
                      min="1"
                    />
                  </div>
                  <div className="space-y-1.5">
                    <label className="text-sm font-medium text-gray-700">Location</label>
                    <input type="text" name="location" value={formData.location} onChange={handleChange} required className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:ring-1 focus:ring-blue-500 outline-none text-sm" />
                  </div>
                  <div className="space-y-1.5">
                    <label className="text-sm font-medium text-gray-700">Application Deadline</label>
                    <input
                      type="date"
                      name="expiryDate"
                      value={formData.expiryDate}
                      onChange={handleChange}
                      min={getTodayDateString()}
                      className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:ring-1 focus:ring-blue-500 outline-none text-sm"
                    />
                  </div>
                </div>
                <div className="space-y-1.5">
                  <label className="text-sm font-medium text-gray-700">Required Skills</label>
                  <input type="text" name="skills" value={formData.skills} onChange={handleChange} required className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:ring-1 focus:ring-blue-500 outline-none text-sm" placeholder="e.g. Nursing, Patient Care" />
                </div>
                <div className="space-y-1.5">
                  <label className="text-sm font-medium text-gray-700">Description</label>
                  <textarea name="description" value={formData.description} onChange={handleChange} rows={4} required className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:ring-1 focus:ring-blue-500 outline-none text-sm resize-none" />
                </div>

                <div className="p-4 rounded-2xl bg-indigo-50/50 border border-indigo-100 space-y-4">
                   <div className="flex items-center gap-2 mb-1">
                      <FiBriefcase className="text-indigo-600" />
                      <h3 className="text-xs font-bold text-indigo-600 uppercase tracking-widest">Branding Details</h3>
                   </div>
                   
                   <div className="space-y-1.5">
                    <label className="block text-[10px] font-bold text-gray-400 uppercase tracking-widest">Company Name</label>
                    <input
                      type="text"
                      name="companyName"
                      value={formData.companyName}
                      onChange={handleChange}
                      className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:ring-1 focus:ring-blue-500 outline-none text-sm text-gray-800 bg-white"
                      placeholder="Timely Health"
                    />
                  </div>

                  <div className="space-y-1.5">
                    <label className="block text-[10px] font-bold text-gray-400 uppercase tracking-widest">About Company</label>
                    <textarea
                      name="aboutCompany"
                      value={formData.aboutCompany}
                      onChange={handleChange}
                      rows="3"
                      className="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:ring-1 focus:ring-blue-500 outline-none text-sm text-gray-800 bg-white resize-none"
                      placeholder="Brief company overview..."
                    ></textarea>
                  </div>
                </div>

                <div className="flex gap-4 pt-4">
                  <button type="button" onClick={() => setIsModalOpen(false)} className="flex-1 py-4 text-sm font-bold text-gray-400 hover:bg-gray-50 rounded-xl transition-all">Cancel</button>
                  <button 
                    type="submit" 
                    disabled={loading || hasDateErrors()} 
                    className={`flex-[2] py-4 text-white rounded-xl font-bold transition-all shadow-lg shadow-blue-600/20 ${
                      loading || hasDateErrors()
                        ? 'bg-gray-400 cursor-not-allowed shadow-none'
                        : 'bg-blue-600 hover:bg-blue-700'
                    }`}
                  >
                    {loading ? "Processing..." : isEditing ? "Update Job" : "Post Job"}
                  </button>
                </div>
                {hasDateErrors() && (
                  <p className="text-xs text-rose-600 text-center mt-2">
                    ⚠️ Please fix the date validation errors before submitting
                  </p>
                )}
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Details Modal */}
      {isDetailsModalOpen && selectedJob && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-gray-900/40 backdrop-blur-[2px] animate-in fade-in duration-200">
          <div className="bg-white w-full max-w-xl rounded-2xl shadow-2xl overflow-hidden relative animate-in slide-in-from-bottom-4 duration-300">
            <div className="px-8 py-6 bg-gradient-to-r from-blue-600 to-indigo-700 text-white">
              <h2 className="text-2xl font-bold">{selectedJob.role}</h2>
              <div className="flex items-center gap-2 mt-1 opacity-90">
                <FiMapPin size={12} />
                <span className="text-[10px] font-bold uppercase tracking-widest">{selectedJob.location} • {selectedJob.department}</span>
              </div>
            </div>
            <div className="p-8 space-y-6">
              <div className="grid grid-cols-2 gap-4">
                <div className="p-3 bg-gray-50 rounded-xl border border-gray-100">
                  <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1">Timing</p>
                  <p className="text-sm font-bold text-gray-900">{selectedJob.startTime} - {selectedJob.endTime}</p>
                </div>
                <div className="p-3 bg-gray-50 rounded-xl border border-gray-100">
                  <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1">Shift Dates</p>
                  <p className="text-sm font-bold text-gray-900">
                    {selectedJob.startDate ? new Date(selectedJob.startDate).toLocaleDateString() : 'N/A'} - {selectedJob.endDate ? new Date(selectedJob.endDate).toLocaleDateString() : 'N/A'}
                  </p>
                </div>
                <div className="p-3 bg-gray-50 rounded-xl border border-gray-100">
                  <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1">Duration</p>
                  <p className="text-sm font-bold text-blue-600">{selectedJob.totalDuration}</p>
                </div>
                <div className="p-3 bg-gray-50 rounded-xl border border-gray-100">
                  <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1">Salary</p>
                  <p className="text-sm font-bold text-emerald-600">{selectedJob.salary}</p>
                </div>
                <div className="p-3 bg-gray-50 rounded-xl border border-gray-100">
                  <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1">Experience</p>
                  <p className="text-sm font-bold text-gray-900">{selectedJob.experience}</p>
                </div>
                <div className={`p-3 rounded-xl border ${selectedJob.expiryDate && new Date(selectedJob.expiryDate) < new Date(new Date().setHours(0,0,0,0)) ? 'bg-rose-50 border-rose-100' : 'bg-gray-50 border-gray-100'}`}>
                  <p className={`text-[10px] font-bold uppercase tracking-widest mb-1 ${selectedJob.expiryDate && new Date(selectedJob.expiryDate) < new Date(new Date().setHours(0,0,0,0)) ? 'text-rose-400' : 'text-gray-400'}`}>Deadline</p>
                  <p className={`text-sm font-bold ${selectedJob.expiryDate && new Date(selectedJob.expiryDate) < new Date(new Date().setHours(0,0,0,0)) ? 'text-rose-600' : 'text-gray-900'}`}>
                    {selectedJob.expiryDate ? new Date(selectedJob.expiryDate).toLocaleDateString() : 'None'}
                  </p>
                </div>
              </div>
              <div className="space-y-2">
                <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Required Skills</p>
                <div className="flex flex-wrap gap-2">
                  {selectedJob.skills ? selectedJob.skills.split(",").map((s, i) => (
                    <span key={i} className="px-3 py-1 bg-indigo-50 text-indigo-600 rounded-lg text-xs font-bold border border-indigo-100">{s.trim()}</span>
                  )) : <span className="text-xs text-gray-400">None specified</span>}
                </div>
              </div>
              <div className="space-y-2">
                <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Job Description</p>
                <div className="p-4 bg-gray-50 rounded-xl text-sm text-gray-700 leading-relaxed max-h-40 overflow-y-auto no-scrollbar border border-gray-100">
                  {selectedJob.description}
                </div>
              </div>

              <div className="p-4 rounded-2xl bg-indigo-50 border border-indigo-100 space-y-3">
                 <div className="flex items-center gap-2">
                    <FiBriefcase className="text-indigo-600" />
                    <span className="text-xs font-bold text-indigo-600 uppercase tracking-widest">Company Branding</span>
                 </div>
                 <div>
                    <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1">Company Name</p>
                    <p className="text-sm font-bold text-gray-800">{selectedJob.companyName || "Timely Health"}</p>
                 </div>
                 {selectedJob.aboutCompany && (
                   <div>
                      <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1">About Company</p>
                      <p className="text-xs text-gray-600 leading-relaxed italic">{selectedJob.aboutCompany}</p>
                   </div>
                 )}
              </div>

              <div className="flex gap-4">
                <button onClick={() => { setIsDetailsModalOpen(false); openEditModal(selectedJob); }} className="flex-1 py-3 text-sm font-bold text-blue-600 bg-blue-50 hover:bg-blue-100 rounded-xl transition-all">Edit Job</button>
                <button onClick={() => setIsDetailsModalOpen(false)} className="flex-1 py-3 text-sm font-bold text-white bg-gray-900 hover:bg-black rounded-xl transition-all">Close</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
    </div>
  );
}

export default PostedShortJobs;